/**
 * Utilities for generating and parsing task view share links.
 * Token = base64(JSON({ property_address, task_type, task_date }))
 */

const VIEW_HASH_PREFIX = '#/view/';

/**
 * Generate a full task view URL with base64-encoded token.
 */
export function generateTaskViewUrl(propertyAddress, taskType, taskDate) {
  const payload = JSON.stringify({
    property_address: propertyAddress,
    task_type: taskType,
    task_date: taskDate,
  });
  const token = btoa(unescape(encodeURIComponent(payload)));
  return `${window.location.origin}${window.location.pathname}${VIEW_HASH_PREFIX}${token}`;
}

/**
 * Parse a base64 token into task view parameters.
 * Returns { property_address, task_type, task_date } or null if invalid.
 */
export function parseTaskViewToken(token) {
  try {
    const json = decodeURIComponent(escape(atob(token)));
    const data = JSON.parse(json);
    if (data.property_address && data.task_type && data.task_date) {
      return data;
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * Check if the current hash is a view route and extract the token.
 * Returns the token string or null.
 */
export function getViewTokenFromHash() {
  const hash = window.location.hash;
  if (hash.startsWith(VIEW_HASH_PREFIX)) {
    return hash.slice(VIEW_HASH_PREFIX.length);
  }
  return null;
}
